var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 39,
    viewBox: "0 0 26 39",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8889 8H9.85941C9.06255 8 8.58579 8.88649 9.0251 9.55131L12.0546 14.1359C12.4499 14.7341 13.3279 14.7341 13.7232 14.1359L16.7527 9.55131C17.192 8.88649 16.7152 8 15.9184 8H12.8889Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7846 2.53357C24.979 2.22548 24.9905 1.83607 24.8145 1.51708C24.6386 1.19809 24.3032 1 23.9389 1H2C1.63426 1 1.29769 1.19967 1.12237 1.52066C0.947056 1.84164 0.96096 2.23273 1.15863 2.54046L10.7613 17.4897C11.0913 18.0033 11.2667 18.6009 11.2667 19.2114C11.2667 19.8083 11.099 20.3931 10.7828 20.8993L1.15189 36.3163C0.959306 36.6245 0.949169 37.013 1.12541 37.3309C1.30165 37.6488 1.63651 37.8461 2 37.8461H23.9389C24.3009 37.8461 24.6347 37.6504 24.8115 37.3345C24.9883 37.0185 24.9806 36.6317 24.7912 36.3231L15.3354 20.9111C15.0216 20.3997 14.8555 19.8115 14.8555 19.2115C14.8555 18.5977 15.0294 17.9965 15.3569 17.4773L24.7846 2.53357Z",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1681 25.4993C12.5639 24.9052 13.4368 24.9052 13.8326 25.4993L18.46 32.4456C18.9027 33.1102 18.4263 34 17.6278 34H8.37288C7.57434 34 7.09791 33.1102 7.54064 32.4456L12.1681 25.4993Z",
    fill: "#39A8F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f2350b3f78edd54f9ef11cd102eff6db.svg";
export { ForwardRef as ReactComponent };